<template>
  <div class="video-detail">
    <div class="video-detail-header">
      <router-link class="ssq-logo" :to="{ name: 'index' }"></router-link>
      <div class="devide-line"></div>
      <router-link
        class="visa-class-title"
        v-if="videoClass.video"
        :to="{
          name:
            videoClass.video.catalog_id === 1 ? 'visaOpenClass' : 'visaGuide',
        }"
      >
        {{ videoClass.video.catalog_id === 1 ? "签证公开课" : "办签指南" }}
      </router-link>
      <div class="fill-space"></div>
      <div class="share-with-friends" v-if="showShare">
        <img class="share-icon" src="../../assets/imgs/acadmy/share.png" />
        <div class="share-text">分享给好友</div>
        <div class="share-qrcode-box">
          <div id="share-qrcode"></div>
          <div class="share-tips">打开微信，使用“扫一扫”</div>
        </div>
      </div>
    </div>
    <div class="bottom-content">
      <div class="center-video-box">
        <video
          v-if="videoClass && videoClass.video && videoClass.video.video"
          :src="videoClass.video.video"
          autoplay
          :muted="true"
          :controls="true"
          height="100%"
          width="100%"
        ></video>
      </div>
      <div class="right-content-box" v-if="videoClass.video">
        <div class="video-class-name">{{ videoClass.video.title }}</div>
        <div class="second-line-info">
          <img src="../../assets/imgs/acadmy/view.png" class="viewed" />
          <span class="view-count">{{ formatViewecCount(videoClass.video.hit) }}</span>
          <img src="../../assets/imgs/acadmy/time.png" class="update-time" />
          <span class="time-text">{{ videoClass.video.update_time }}</span>
        </div>
        <div class="top-devide-line"></div>
        <div class="rest-content-box-wrapper">
          <div class="rest-content-box">
            <div
              class="class-content-detail"
              v-html="videoClass.video.introduction"
            ></div>
            <div class="bottom-devide-line"></div>
            <div class="other-video-wrapper">
              <div class="other-videos">
                <router-link
                  class="video-item"
                  v-for="video in videoClass.other_video"
                  :key="video.id"
                  target="_blank"
                  :to="{ name: 'videoDetail', params: { id: video.id } }"
                >
                  <img class="left-video-img" :src="video.cover" />
                  <div class="right-video-content">
                    <div class="video-title">{{ video.title }}</div>
                    <div class="learned">{{ formatViewecCount(video.hit) }}人学过</div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import knowledgeService from "../../services/knowledge-service";
import { envPrefix } from "../../libs/env";

export default {
  name: "video-detail",
  data() {
    return {
      videoClass: {},
      showShare: true,
    };
  },
  methods: {
    formatViewecCount:knowledgeService.formatViewecCount,
    loadVideoDetail(id) {
      knowledgeService
        .loadVideoClassDetail(id)
        .then((data) => {
          this.videoClass = data;
          this.generateQrcode(data.video.id);
        })
        .catch((err) => {
          this.showShare = false;
          if (err && err.msg && err.msg.indexOf("删除") > -1) {
            this.$router.replace({ name: "academy" });
          }
        });
    },
    generateQrcode(id) {
      var qrcode = new QRCode("share-qrcode", {
        text: `https://${envPrefix}h5.666visa.cn/#/visa-class/${id}?from=2`,
        width: 180,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
  },
  created() {
    this.loadVideoDetail(+this.$route.params.id);
  },
};
</script>

<style lang="less" scoped>
.video-detail {
  box-sizing: border-box;
  display: flex;
  height: calc(~"100vh - 68px");
  width: 100%;
  flex-direction: column;
  * {
    box-sizing: border-box;
  }
  .video-detail-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 68px;
    background-color: #1d1d1d;
    z-index: 100;
    .ssq-logo {
      cursor: pointer;
      margin-left: 40px;
      width: 94px;
      height: 26px;
      background-image: url("../../assets/imgs/acadmy/video-logo.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
    }
    .devide-line {
      margin: 0 20px;
      width: 1px;
      height: 24px;
      background: #ffffff;
      border-radius: 1px;
      opacity: 0.2;
    }
    .visa-class-title {
      font-size: 24px;
      font-weight: 600;
      color: #ffffff;
      line-height: 33px;
    }
    .fill-space {
      flex: 1;
    }
    .share-with-friends {
      display: flex;
      align-items: center;
      position: relative;
      cursor: pointer;
      margin-right: 40px;
      .share-icon {
        width: 18px;
        height: 18px;
      }
      .share-text {
        margin-left: 8px;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
      }
      .share-qrcode-box {
        display: none;
        position: absolute;
        left: 6px;
        top: 32px;
        transform: translateX(-50%);
        flex-direction: column;
        align-items: center;
        width: 200px;
        background: #ffffff;
        border: 1px solid #e9eef2;
        padding: 10px;
        #share-qrcode {
          width: 180px;
          height: 180px;
        }
        .share-tips {
          font-size: 14px;
          font-weight: 400;
          color: #2f333d;
          line-height: 20px;
          margin-top: 8px;
        }
      }
      &:hover {
        .share-qrcode-box {
          display: flex;
        }
      }
    }
  }
  .bottom-content {
    flex: 1;
    display: flex;
    height: 100%;
    overflow: hidden;
    .center-video-box {
      flex: 1;
      background-color: #222427;
      height: calc(~"100vh - 68px");
    }
    .right-content-box {
      display: flex;
      flex-direction: column;
      padding: 24px 0;
      background-color: #222427;
      width: 420px;
      .video-class-name {
        font-size: 24px;
        font-weight: 600;
        color: #ffffff;
        line-height: 33px;
        word-break: break-all;
        padding: 0 30px;
      }
      .second-line-info {
        margin-top: 12px;
        display: flex;
        align-items: center;
        padding: 0 30px;
        .viewed {
          width: 16px;
          height: 12px;
        }
        .view-count {
          font-size: 14px;
          font-weight: 400;
          color: #91999f;
          line-height: 14px;
          margin-left: 3px;
        }
        .update-time {
          margin-left: 20px;
          width: 14px;
          height: 14px;
        }
        .time-text {
          margin-left: 3px;
          font-size: 14px;
          font-weight: 400;
          color: #91999f;
          line-height: 14px;
        }
      }
      .top-devide-line {
        margin-top: 24px;
        width: 100%;
        height: 1px;
        background: #1d1d1d;
        padding: 0 30px;
      }
      .rest-content-box-wrapper {
        flex: 1;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 8px; /*定义纵向滚动条宽度*/
        }

        &::-webkit-scrollbar-thumb {
          /*滚动条内部滑块*/
          border-radius: 8px;
          background-color: hsla(220, 4%, 58%, 0.3);
          transition: background-color 0.3s;
        }

        &::-webkit-scrollbar-thumb:hover {
          /*鼠标悬停滚动条内部滑块*/
          background: #bbb;
        }

        &::-webkit-scrollbar-track {
          /*滚动条内部轨道*/
          background: #3e3232;
        }
        .rest-content-box {
          .class-content-detail {
            padding: 12px 30px;
            color: white;
            word-break: break-all;
            font-size: 16px;
            line-height: 24px;
          }
          .bottom-devide-line {
            width: 100%;
            height: 1px;
            background: #1d1d1d;
          }
          .other-video-wrapper {
            margin-top: 24px;
            padding: 0 30px;
            .other-videos {
              display: flex;
              flex-direction: column;
              .video-item {
                display: flex;
                align-items: center;
                margin-bottom: 24px;
                .left-video-img {
                  width: 129px;
                  height: 71px;
                  flex-shrink: 0;
                }
                .right-video-content {
                  margin-left: 16px;
                  display: flex;
                  flex-direction: column;
                  .video-title {
                    font-size: 16px;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 22px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                  .learned {
                    margin-top: 8px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #91999f;
                    line-height: 20px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>


<style lang="less">
.class-content-detail {
  ul {
    list-style-type: disc;
    padding-left: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/VideoDetail.vue